// extracted by mini-css-extract-plugin
export default {"save-filter-wrapper":"SaveFilters_save-filter-wrapper__ZB5BE","btn-save-filters":"SaveFilters_btn-save-filters__RYXiG","save-icon":"SaveFilters_save-icon__k7S3T"};